import { ReactNode, useContext } from 'react';
import styled from 'styled-components';
import {
  AssociateSetupContext,
  AuthenticationContext,
  VsWebsocketProvider,
} from '@vs-online-only-app/state';
import { CenteredLoader } from '@vs-online-only-app/ui';
import { Typography } from '@mui/material';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

type Props = {
  children: ReactNode;
};

const SimplePrivateRoute = ({ children }: Props) => {
  const { isAuthenticated, verifyAuthenticatedState } = useContext(
    AuthenticationContext,
  );
  const { hasCompletedProfileSetup, hasCompletedIntroModules } = useContext(
    AssociateSetupContext,
  );

  if (['idle', 'loading', 'error'].includes(verifyAuthenticatedState)) {
    return (
      <CenteredLoader>
        <Typography variant="body1">
          {verifyAuthenticatedState === 'error'
            ? 'Authentication seems invalid. Page should reload within a few seconds.'
            : 'Verifying authentication'}
        </Typography>
      </CenteredLoader>
    );
  }

  if (!isAuthenticated || !hasCompletedProfileSetup || !hasCompletedIntroModules) {
    return (
      <Wrapper>
        <Typography variant="body1">Access Denied</Typography>
      </Wrapper>
    );
  }

  return (
    <VsWebsocketProvider>
      {children}
    </VsWebsocketProvider>
  );
};

export default SimplePrivateRoute;
